<template>
  <div
    class="tailwind"
    :class="cssClass"
  />
</template>

<script>
import { ref } from 'vue'

export default {
  setup() {
    const cssClass = ref([
      'sm:h-auto',
      'h-2px',
      'h-1px'
    ])

    return {
      cssClass
    }
  }
}
</script>
